import React, { FC, useState, useRef, useEffect, useCallback } from 'react'
import { PopoverProps } from './Popover.types'
import './Popover.scss'

/**
 * Adel Popover
 * https://digital.qa.ameriprise.com/adel/components/popover/popover.hbs?theme=amp.next
 */
export const Popover: FC<PopoverProps> = props => {
  const { items, currentDisplayIndex, hiddenMessage, testId } = props
  const displayLabel = items[Number(currentDisplayIndex)].text
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const popoverRef = useRef<HTMLButtonElement>(null)

  const handleWindowClick = useCallback(
    (e: { target: any }) => {
      if (!popoverRef.current || popoverRef.current.contains(e.target) || !isOpen) {
        return
      }
      setIsOpen(false)
    },
    [isOpen]
  )

  useEffect(() => {
    window.addEventListener('click', handleWindowClick)
    return () => {
      window.addEventListener('click', handleWindowClick)
    }
  }, [handleWindowClick])

  return (
    <button
      className='u-block icon-globe u-md-hidden u-sm-hidden Link Link--trigger u-linkClean u-flex u-flexAlignItemsCenter u-posRelative'
      ref={popoverRef}
      onClick={() => {
        setIsOpen(() => !isOpen)
      }}
      aria-haspopup='true'
      aria-expanded={isOpen}
      data-testid={testId ?? null}>
      <div className='u-flex u-flexAlignItemsCenter u-flexJustifyBetween'>
        <span
          aria-hidden='true'
          className='adel-material-symbols-20 u-textColorInherit u-textSizeMsrp2'>
          language
        </span>
        <span className='u-marginLeft1gu'>{displayLabel}</span>
      </div>
      <span className='u-hiddenVisually'>{hiddenMessage}</span>
      {isOpen && (
        <div className='Popover Popover--Compound Popover--Custom u-md-hidden u-sm-hidden is-visible'>
          <ul className='List List--selectable u-paddingVert1gu'>
            {items.map(item => {
              return (
                <li className='List-item' key={item.text}>
                  <a
                    className='Link--inlineBlock u-linkClean'
                    href={item.href}
                    data-analytics={item.analytics}
                    data-tracking='Link'>
                    {item.text}
                  </a>
                </li>
              )
            })}
          </ul>
        </div>
      )}
    </button>
  )
}
